import { SearchUserEnriched } from 'lib-search-types';
import _sortBy from 'lodash/sortBy';

import { getStatus } from './getStatus';

export const sortMembers = (
  members: readonly SearchUserEnriched[],
): SearchUserEnriched[] =>
  _sortBy(members, [
    (member) => {
      const rank = { working: 1, away: 2, offline: 3 };
      return rank[getStatus(member)];
    },
    (member) => member.name?.toLowerCase() ?? '',
  ]);
